module.exports = __webpack_public_path__ + "static/your-money-or-your-life-b72914d6d1b1c6beb402575a3a7cc7be.jpg";